export default "__VITE_ASSET__CyLqtMYA__"